import StorageUtil from "./storage";

/**
 * 获取当前运行平台
 * @returns 'wechat' | 'web' | 'other'
 */
export function getCurrentPlatform(): 'wechat' | 'web' | 'other' {
  try {
    const platform = StorageUtil.getItem("platform")
    if(platform){
      return platform.value;
    }
    const systemInfo = uni.getSystemInfoSync();
    console.log(systemInfo)
    // 微信小程序平台标识为 'mp-weixin'
    if (systemInfo.uniPlatform === 'mp-weixin') {
      StorageUtil.setItem("platform", "wechat");
      return 'wechat';
    }
    // H5网页端平台标识为 'h5'
    else if (systemInfo.uniPlatform === 'web') {
      StorageUtil.setItem("platform", "web");
      return 'web';
    }
    // 其他平台（如App、支付宝小程序等）
    else {
      StorageUtil.setItem("platform", "other");
      return 'other';
    }
  } catch (e) {
    console.error('获取平台信息失败:', e);
    return 'other';
  }
}
